let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("atfo8")).then(() => parcelRequire('3Vv9e'));